export function SelectedTag({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-0.5 bg-muted-bg text-primary border border-theme-border-subtle rounded px-1.5 py-0.5 text-xs">
      {label}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
        aria-label={`Remove ${label}`}
        className="hover:text-secondary ml-0.5 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
      >
        ×
      </button>
    </span>
  )
}
